import { disableBodyScroll, enableBodyScroll } from '~js/utils/dom';
import { renderProductDrawerModal } from '../sections/card-drawer-product';

class QuickAddProductDrawer {
  constructor(card) {
    if (window.innerWidth >= 750) {
      this.overlay = card.querySelector(
        '.js-quick-product-drawer-overlay-desktop',
      );
    } else {
      this.overlay = document.querySelector(
        '.js-quick-product-drawer-overlay-mobile',
      );
    }
    this.drawer = this.overlay.querySelector('.js-quick-product-drawer');
    this.section = this.drawer.querySelector(
      '.js-quick-product-drawer-section-content',
    );
    this.closeButton = null;
    this.isLoading = false;
    this.handle = null;

    this.initializeCloseButton();
  }

  // Show the drawer by manipulating CSS classes
  show() {
    this.overlay.parentElement.classList.add('is-drawer-open');
    if (window.innerWidth <= 750) disableBodyScroll();
  }

  // Hide the drawer by manipulating CSS classes
  hide() {
    this.overlay.parentElement.classList.remove('is-drawer-open');
    if (window.innerWidth <= 750) enableBodyScroll();
  }

  // Initialize close button and add event listener to close the drawer
  initializeCloseButton() {
    const closeDrawer = () => this.hide();
    if (this.closeButton) {
      this.closeButton.removeEventListener('click', closeDrawer);
      this.closeButton.addEventListener('click', closeDrawer);
    }
  }

  /**
   * Load and display product drawer content based on product handle.
   * @param {String} productHandle - The product handle used to fetch data.
   */
  async loadAndShow(productHandle, card) {
    // Avoid reloading if the same handle is already loaded
    if (this.handle === productHandle) {
      this.show();
      return;
    }

    if (this.isLoading) return;
    this.isLoading = true;
    this.handle = productHandle;

    try {
      const res = await fetch(
        `/products/${this.handle}?section_id=card-drawer-product`,
      );
      if (!res.ok) throw new Error('Fetch of quickAddProductDrawer failed');

      const productHTML = await res.text();
      renderProductDrawerModal(this.section, productHTML, card);

      // Initialize close button after rendering content
      this.closeButton = this.section.querySelector(
        '.js-quick-product-close-btn',
      );
      if (this.closeButton) this.initializeCloseButton();

      this.show();
    } catch (err) {
      console.error(err.message);
      alert("Sorry, we couldn't load the Quick Add Product feature");
    } finally {
      this.isLoading = false;
    }
  }

  // Static method to handle drawer triggering and instance management
  static trigger(handle, card) {
    // Reuse or create an instance for each unique card
    if (!QuickAddProductDrawer.instances.has(card)) {
      QuickAddProductDrawer.instances.set(
        card,
        new QuickAddProductDrawer(card),
      );
    }
    const drawerInstance = QuickAddProductDrawer.instances.get(card);
    drawerInstance.loadAndShow(handle, card);
  }

  // Static method to hide the drawer for a specific card
  static hide(card) {
    const drawerInstance = QuickAddProductDrawer.instances.get(card);
    if (drawerInstance) {
      drawerInstance.hide();
    }
  }
}

// Store instances to manage multiple drawers
QuickAddProductDrawer.instances = new WeakMap();

export { QuickAddProductDrawer };
